import styled from "@emotion/styled/macro";
import React, { Fragment } from "react";

import { Spacer } from "Components/Common/Spacer/index";
import {
  FlexWrapperT2,
  FlexWrapperT4,
  FlexWrapperT6,
} from "Components/Common/Wrapper/FlexWrapper";
import {
  TypographyT13,
  TypographyT17,
  TypographyT33,
  TypographyT34,
} from "Components/Common/Typography/index";
import RateInfoCard from "./RateInfoCard";
import { Wrapper } from "Components/Common/Wrapper/index";
import { LabelT2 } from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
const options = [
  { value: "Lucknow", label: "Lucknow" },
  { value: "All", label: "All" },
  { value: "Mundra", label: "Mundra" },
];
const FreightDetailsT4 = () => {
  return (
    <Fragment>
      <FreightDetailsWrapper>
        <TypographyT33>River Freight</TypographyT33>
        <Spacer spacing={"5px 0px"} />
        <FlexWrapperT6>
          <TableWrapper>
            <Table>
              <THead>
                <Tr>
                  <Th>
                    <TypographyT17>NA</TypographyT17>
                  </Th>
                  <Th></Th>
                  <Th></Th>
                </Tr>
              </THead>
              <TBody>
                <Tr>
                  <Td></Td>
                  <Td></Td>
                  <Td></Td>
                </Tr>
              </TBody>
            </Table>
          </TableWrapper>
          <Wrapper>
            <Wrapper>
              <LabelT2>Container Type</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1 options={options} />
            </Wrapper>
            <Wrapper>
              <LabelT2>Delivery Type</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1 options={options} />
            </Wrapper>
            <Wrapper>
              <LabelT2>Loading Weight</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1 options={options} />
            </Wrapper>
          </Wrapper>
        </FlexWrapperT6>
      </FreightDetailsWrapper>
    </Fragment>
  );
};

export default FreightDetailsT4;

const RateInfoCardT1 = (props) => {
  const { isActive, isLActive, labelOfL, rate } = props;
  return (
    <Fragment>
      <Td bgColor={!!isActive && "#4E9757"}>
        <RateInfoCard
          rate={rate}
          labelOfL={labelOfL}
          isActive={!!isActive}
          isLActive={isLActive}
          showRateVariation={true}
        />
        <Spacer spacing={"3px 0px"} />
        <FlexWrapperT4>
          <TypographyT34>TAT - 6 Days</TypographyT34>
          <TypographyT34>Distance - 700Km</TypographyT34>
        </FlexWrapperT4>
      </Td>
    </Fragment>
  );
};

const FreightDetailsWrapper = styled.div``;

const TableWrapper = styled.div`
  overflow: auto;
  width: calc(100% - 150px);
`;

const Table = styled("table")`
  width: 100%;
  border-spacing: 0px;
  border-radius: 3px;
  box-shadow: 0px 0px 2px 1px #d1d1d1;
`;

const Th = styled("th")`
  padding: 10px;
  background-color: #d4e2fa;
  text-align: left;
  border-top: 1px solid #677586;
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;

const THead = styled("thead")`
  & ${Th}:last-of-type {
    border-top-right-radius: 3px;
  }
  & ${Th}:first-of-type {
    border-top-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
const TBody = styled("tbody")``;
const Td = styled("td")`
  padding: 10px;
  background-color: ${({ bgColor }) => (!!bgColor ? bgColor : "#f6f9ff")};
  border-bottom: 1px solid rgba(82, 138, 234, 0.45);
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;
const Tr = styled("tr")`
  & ${Td}:last-of-type {
    border-bottom-right-radius: 3px;
  }
  & ${Td}:first-of-type {
    border-bottom-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
